import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import ObjectChangeSetsList from './ObjectChangeSetsList';
import ButtonControls from '@rd-web-markets/shared/dist/technical_review/ButtonControls';
import { useTranslation } from 'react-i18next';
import ClientReviewMailerModal from '@rd-web-markets/shared/dist/claim_group/ClientReviewMailerModal';
import ObjectChangeSetsListWithSnapshots from '@rd-web-markets/shared/dist/technical_review/ObjectChangeSetsListWithSnapshots';
import claimGroupChangeSetsService from '@rd-web-markets/shared/dist/services/claim_groups/claim_group_change_sets.service';
import { Loading } from '@rd-web-markets/shared/dist/util';

const ClaimGroupClientReview = ({
  setClaimGroup,
  claimGroup,
  loading,
  company,
  createChangeSetForClient,
  approveChangeSet,
  rejectChangeSet,
  finalizeChangeSet
}) => {
  const reviewType = 'client_review';
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const [modalShow, setModalShow] = useState(false);

  const {
    activeChangeSet,
    changeSets,
    fetchChangeSets,
  } = claimGroupChangeSetsService.useCrud(claimGroup.id);

  const reviewedClaimGroup = {
    ...claimGroup,
    active_change_set: activeChangeSet,
    change_sets: changeSets,
  };

  const createChangeSetForClientAndRefresh = async (...args) => {
    await createChangeSetForClient(...args);
    await fetchChangeSets();
  };

  const finalizeChangeSetAndRefresh = async (reviewedObject) => {
    await finalizeChangeSet(reviewedObject);
    await fetchChangeSets();
  };

  const approveChangeSetAndRefresh = async (reviewedObject) => {
    await approveChangeSet(reviewedObject);
    await fetchChangeSets();
  };

  const rejectChangeSetAndRefresh = async (reviewedObject) => {
    await rejectChangeSet(reviewedObject);
    await fetchChangeSets();
  };

  if (changeSets === undefined) {
    return <Loading />;
  }

  const disabled = !changeSets.find((changeSet) => changeSet.review_type === 'consultant_review');

  return (
    <>
      <h2 className='text-primary mb-4'>{t('client_review')}</h2>
      <Card className='shadow border-0'>
        <Card.Body>
          {claimGroup && (
            <>
              <ClientReviewMailerModal
                setClaimGroup={setClaimGroup}
                claimGroup={claimGroup}
                show={modalShow}
                setModalShow={setModalShow}
                loading={loading}
                createChangeSetForClient={createChangeSetForClientAndRefresh}
                reviewType={reviewType}
                reviewedObjectClass={'ClaimGroup'}
                reviewedObject={reviewedClaimGroup}
              />
              <ButtonControls
                reviewedObject={reviewedClaimGroup}
                reviewedObjectClass={'ClaimGroup'}
                loading={loading}
                company={company}
                createChangeSet={createChangeSetForClientAndRefresh}
                finalizeChangeSet={finalizeChangeSetAndRefresh}
                approveChangeSet={approveChangeSetAndRefresh}
                rejectChangeSet={rejectChangeSetAndRefresh}
                setModalShow={() => setModalShow(true)}
                buttonName={t('click_to_start_client_review')}
                managerQAReviewButtonName={t('under_client_review')}
                acceptChangesButtonText={t('accept_client_review_changes')}
                rejectChangesButtonText={t('reject_client_review_changes')}
                reviewType={reviewType}
                underManagerReviewButtonName={t('under_client_review')}
                disabledBeforeManagerReview={disabled}
              />

              <ObjectChangeSetsListWithSnapshots object={reviewedClaimGroup} reviewType={'client_review'} resetData={fetchChangeSets}/>

            </>
          )}

          {/* If by any chance */}
          {!claimGroup && <span>Please create a Claim Group</span>}
        </Card.Body>
      </Card>
    </>
  );
};

export default ClaimGroupClientReview;
